export const toCapitalisedSpaced = (
  str: string,
  oldDelim = "_",
  newDelim = " ",
  toLowerCase = true,
) => {
  // if string is empty, return an empty string
  if (!str || typeof str !== "string") return "";

  // transform string to lowercase if needed: default
  const modStr = toLowerCase ? str.toLowerCase() : str;

  // an array of fragments, split by the old delimiter: default _
  const fragments = modStr.split(oldDelim);

  // an array of new fragments, with first in uppercase and rest in lowercase: default
  for (let i = 0; i < fragments.length; i++) {
    fragments[i] = fragments[i].charAt(0).toUpperCase() + fragments[i].slice(1);
  }

  // construct a string with new delimiter: default " "
  return fragments.join(newDelim);
};
